import { FC } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { DriveList } from "@/views/drive/driveList";
import { useDriveList } from "@/views/drive/hooks/use-drive-list";
import { DriveSearch } from "@/views/drive/driveSearch";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const ApplyPromptLibraryItemDialog: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { displayItems, itemsPerPage, currentPage } = useDriveList({});

  return (
    <div className="min-w-10">
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-h-[100vh] w-[100%] max-w-[75%] overflow-y-scroll">
          <div className="py-4">
            <DriveSearch folderId={undefined} />
          </div>
          <DriveList
            sortItemsByDate={true}
            items={displayItems}
            parentFolder={null}
            isRootFolder={true}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            hiddenButtons={["snapShot", "chronology", "options"]}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
